"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const it_1 = __importDefault(require("date-fns/locale/it")); //
const dateItIT = {
    name: 'it-IT',
    locale: it_1.default
};
exports.default = dateItIT;
